import { render, staticRenderFns } from "./cOrderPurcharse.vue?vue&type=template&id=89bc6214&"
import script from "./cOrderPurcharse.vue?vue&type=script&lang=js&"
export * from "./cOrderPurcharse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports